<script setup>
import Footer from '@/components/common/home-footer.vue'
import { Header, Desc, Block, Light, Tickets, Btn, Plate, About } from '@/mock/618.js'
function toJump(url) {
  window.open(url)
}
</script>

<template>
  <div class="body">
    <img class="bodyHeader" :src="Header.pic" :alt="Header.alt" />
    <div class="wrap">
      <img class="wrapDesc" :src="Desc.pic" :alt="Desc.alt" />
      <img class="wrapBlock" :src="Block.pic" :alt="Block.alt" >
      <!-- <img class="wrapLight" :src="Light.pic" :alt="Light.alt" /> -->
      <!-- <div class="wrapNav">
        <div class="wrapNavTitle">限量抢早鸟票</div>
        <div class="wrapNavLine"></div>
        <div class="wrapNavDesc">
          为回馈十年来新老朋友的支持，ISC在全网购物狂欢节之际奉献感恩钜惠，限量放送ISC
          2023早鸟票100张！锁定本年度最精彩安全盛宴，6月18日晚8点准时开抢！
        </div>
        <img class="wrapNavPlate" :src="Plate.pic" :alt="Plate.alt" />
      </div> -->
      <img class="wrapNavPlate" :src="Plate.pic" :alt="Plate.alt" />
      <div class="wrapTik">
        <img
          class="wrapTikImg"
          v-for="item in Tickets"
          :key="item.id"
          :src="item.pic"
          :alt="item.alt"
          @click="toJump(item.url)"
        />
      </div>
      <!-- <img class="wrapTog" :src="Togther.pic" :alt="Togther.alt" /> -->
      <!-- <img class="wrapBtn" :src="Btn.pic" :alt="Btn.alt" @click="toJump(Btn.url)" /> -->
      <img
        class="wrapAbout"
        :src="About.pic"
        :alt="About.alt"
      />
    </div>
  </div>
  <Footer />
</template>

<style lang="scss" scoped>
.body {
  width: 100%;
  text-align: center;
  background-color: #fff;
  &Header {
    width: 100%;
  }
}
.wrap {
  width: 100%;
  margin: auto;
  &Desc {
    width: 926px;
    margin: 127px auto 0;
    display: block;
  }
  &Block {
    margin: 190px auto 190px;
    width: 969px;
    display: block;
  }
  
  &NavPlate {
    width: 979px;
    display: block;
    margin: 0 auto 60px;
  }

  // &Nav {
  //   margin: 232px 0 60px;
  //   &Title {
  //     font-weight: bold;
  //     font-size: 54px;
  //     color: #0d0d0d;
  //     line-height: 60px;
  //   }
  //   &Line {
  //     width: 100px;
  //     height: 10px;
  //     background: #de2112;
  //     margin: 41px auto 78px;
  //   }
  //   &Plate {
  //     display: inline-block;
  //     margin-top: 57px;
  //     width: 979px;
  //   }
  //   &Desc {
  //     width: 925px;
  //     font-size: 34px;
  //     color: #0d0d0d;
  //     line-height: 60px;
  //     margin: auto;
  //     text-align: left;
  //   }
  // }
  &Tik {
    width: 906px;
    margin: auto;
    &Img {
      display: inline-block;
      width: 906px;
      height: 332px;
      cursor: pointer;
      margin-bottom: 20px;
    }
    &Img:last-child {
      margin-bottom: 0;
    }
  }
  &Tog {
    display: block;
    width: 926px;
    margin: 187px auto 142px;
  }
  &Btn {
    width: 944px;
    cursor: pointer;
    margin: 99px 0 313px;
  }
  &About {
    display: block;
    width: 926px;
    margin: 190px auto 0;
    padding-bottom: 142px;
  }
}
</style>
